import React from 'react';
import { IMadlenAIContent } from '../../../../models/components/madlen-integrations';
import { IPagedQuery } from '../../../../models/components/paginate';
import Translator from '../../../../core/i18n';
import { Common } from '../../../../core/common';
import moment from 'moment';
import Paginate from '../../../table/paginate';
import imgAnn from '../../../../static/images/empty-polling-qr.svg';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../models/action/core';
import { getTermName } from '../../../../utils';



interface ICommonTableProps {
    activitiesData: { results: IMadlenAIContent[] | null; filters: IPagedQuery; };
    onPageChange: (page: number) => void;
}

const T = Translator.create();
let _common: Common = new Common();

const CommonTable: React.FC<ICommonTableProps> = ({ activitiesData, onPageChange }) => {

    const termWeeks = useSelector((state: IAppState) => state.coursePage.courseContentTermWeeks);

    if (activitiesData?.results?.length === 0) {
        return (
            <div className='d-flex flex-column align-items-center justify-content-center cursor-default mb-5'>
                <img src={imgAnn} alt="Announcement" />
                <span className='mt-4 text-center'>
                    <b>{T.t('r_gen_no_content')}</b>
                </span>
                <span className='text-center mb-5'>
                    {T.t('r_gen_no_content_description')}
                </span>

            </div>
        );
    }

    return (
        <div>

            <div className='p-2'>
                <ul className="px-3" style={{ listStyle: 'none' }}>
                    <li>
                        <div className="row  align-items-center">
                            <div className="col-3 d-flex justify-content-start align-items-center">
                                <div className="tick-radio position-relative">
                                    {/* <input
                                //onChange={this.selectAll}
                                type="checkbox"
                                //checked={this.state.disAllowedActivityIds.length === 0 && this.state.isAll}
                                name="demo"
                                defaultValue="one"
                                id="radio-three"
                                className="form-radio mr-2"
                                style={{ zIndex: "unset" }}
                            /> */}
                                </div>
                                <b>{T.t('r_gen_activity_name')}</b>
                            </div>
                            <div className="col-3">
                                <b>{T.t('r_gen_registration_date')}</b>
                            </div>
                            <div className="col-3">
                                <b>{T.t('r_source_weeks')}</b>
                            </div>
                            <div className="col-3">
                                <b>{T.t('r_gen_learning_outcome')}</b>
                            </div>
                        </div>
                    </li>
                    {activitiesData?.results?.map((item: any) => {
                        return (
                            <li style={{ background: "none" }} className='pt-2 pb-2' key={item.trackingGuid}>
                                <div className="row align-items-center">
                                    <div className="col-3 d-flex justify-content-start align-items-center">
                                        <div className="tick-radio position-relative mr-2">
                                            {/* <input
                                        type="checkbox"
                                        name={`chbx_${item.activityId}`}
                                        id={`chbx_${item.activityId}`}
                                        className="form-radio mr-2"
                                        style={{ zIndex: "unset" }}
                                        onChange={() => handleCheckboxChange(activity)}
                                        checked={isChecked}
                                    /> */}
                                        </div>
                                        {item.activityType && (
                                            <img
                                                className="mr-1"
                                                style={{ width: '16px' }}
                                                src={_common.GetActivityTypeIcons(item.activityType!)}
                                                alt="Link Icon" />
                                        )}
                                        <span>
                                            {item?.activityName}
                                        </span>
                                    </div>
                                    <div className="col-3" style={{ fontWeight: 500 }}>
                                        {moment(item?.createdDate).format('DD.MM.YYYY HH:mm')}
                                    </div>
                                    <div className="col-3" style={{ fontWeight: 500 }}>
                                        {getTermName(item.termWeekId, termWeeks || [], T) || T.t('r_gen_no_week_info')}
                                    </div>
                                    <div className="col-3">
                                        <span>
                                            {item.learningOutcomeValue ?? T.t('r_gen_learning_outcome_not_selected')}
                                        </span>
                                    </div>
                                </div>
                            </li>
                        );
                    })}

                    {(activitiesData?.results ?? []).length > 0 && (
                        <Paginate filters={activitiesData.filters} onPageChange={(page) => onPageChange(page)} />
                    )}
                </ul>

            </div>
        </div>
    );
};

export default CommonTable;